import * as types from './_types';
import mockDashboardData from './dashboardMockData';

/**
 * Dashboard data fetching.
 *
 * TODO: Replace mock data with real API call:
 *   GET <DASHBOARD_API_URL>/api/member
 *   Headers: { Authorization: `Bearer <session_token>` }
 *   -or- session cookie (HttpOnly JWT)
 *
 * Required backend queries (from pike13-reporting-v3/member-dashboard):
 *   1. pike13_clients + tenants → member info (findMemberByEmail)
 *   2. workout_snapshots → logbook stats, weights, progressions (getMemberByEmail)
 *   3. workout_snapshots with ROW_NUMBER() PARTITION BY (gym, sex) → leaderboard (getMemberLeaderboardPositions)
 *      NOTE: leaderboard must be filtered to members of the same sex at the same gym.
 *   4. workout_snapshots with PERCENTILE_CONT() → demographic comparison (getMemberDemographicComparison)
 *   5. schedule_enrollments → attendance streak (getAttendanceStreak)
 *   6. Pike13 API person_plans report → membership tenure (getMembershipTenure)
 *   7. Pike13 API enrollments report → upcoming sessions (getUpcomingSessions)
 */

export const fetchDashboard = () => {
  return (dispatch) => {
    dispatch({ type: types.DASHBOARD_FETCH_START });

    // TODO: Replace with real API call
    // Example:
    //   const response = await apiClient.get('/api/member');
    //   dispatch({ type: types.DASHBOARD_FETCH_SUCCESS, data: response.data });
    setTimeout(() => {
      dispatch({
        type: types.DASHBOARD_FETCH_SUCCESS,
        data: mockDashboardData,
      });
    }, 500);
  };
};
